import { useEffect, useState } from "react";
import { Vote, Newspaper, IdCard, CalendarDays, MessageCircle, Wallet, LogIn } from "lucide-react";

export default function Login() {
  const [assocName, setAssocName] = useState("Associazione Culturale");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`)
      .then(r => r.json()).then(d => setAssocName(d.association_name)).catch(() => {});
  }, []);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const features = [
    { icon: Vote, label: "Votazioni a distanza" },
    { icon: Newspaper, label: "News & annunci" },
    { icon: IdCard, label: "Tessere automatiche" },
    { icon: CalendarDays, label: "Calendario riunioni" },
    { icon: MessageCircle, label: "Community WhatsApp" },
    { icon: Wallet, label: "Trasparenza spese" },
  ];

  return (
    <div className="min-h-screen flex flex-col md:flex-row" data-testid="login-page">
      {/* Left / hero */}
      <div className="md:w-3/5 relative overflow-hidden flex items-center justify-center p-8 md:p-16" style={{background: "linear-gradient(135deg, #FAF7F2 0%, #F3EEE4 100%)"}}>
        <div className="absolute inset-0 dot-grid opacity-30" />
        <div className="relative z-10 max-w-xl fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase text-[#EF3E36] border border-[#EF3E36]/20 bg-white">
            <span className="w-1.5 h-1.5 rounded-full bg-[#EF3E36]" />
            Piattaforma Soci
          </div>
          <div className="mt-6 inline-flex items-center justify-center">
            <img src="/logo.png" alt="Amunì" loading="eager" className="w-44 sm:w-56 h-auto object-contain" />
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-6 text-[#2B3A33] leading-[1.05]">
            {assocName}
          </h1>
          <p className="mt-5 text-base sm:text-lg text-[#6B6558] leading-relaxed">
            Il cuore digitale della nostra associazione: vota, informati, gestisci il tesseramento
            e resta connesso con la community — tutto in un solo posto.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="mt-8 group inline-flex items-center gap-3 px-6 py-3.5 rounded-2xl terracotta-btn font-semibold shadow-lg shadow-[#EF3E36]/20"
          >
            <LogIn className="w-5 h-5" />
            <span>Accedi con Google</span>
            <span className="w-2 h-2 rounded-full bg-white/70 group-hover:bg-white transition" />
          </button>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {features.map((f) => (
              <div key={f.label} className="flex items-center gap-2 text-sm text-[#2B3A33]">
                <f.icon className="w-4 h-4 text-[#EF3E36]" />
                <span className="font-medium">{f.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right / image */}
      <div className="md:w-2/5 relative hidden md:block">
        <img
          src="https://images.unsplash.com/photo-1515187029135-18ee286d815b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjdWx0dXJhbCUyMGFzc29jaWF0aW9uJTIwY29tbXVuaXR5JTIwZXZlbnQlMjBhcnQlMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODg4OTg4MjB8MA&ixlib=rb-4.1.0&q=85"
          alt="cultura community"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2B3A33]/70 via-transparent to-transparent" />
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <div className="text-xs uppercase tracking-widest font-semibold text-[#FEF3C7]">Cultura è comunità</div>
          <div className="font-display text-2xl mt-2">Costruiamo insieme la nostra storia.</div>
        </div>
      </div>
    </div>
  );
}
